import { makeStyles } from "@material-ui/core/styles";

export const activationConfirmationDialogStyles = makeStyles((theme) => ({
  leftMarginLink: {
    marginLeft: 10,
  },
  unorderedList: {
    paddingLeft: theme.shape.padding,
    "& li": {
      paddingBottom: theme.shape.padding,
    },
  },
}));
